import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app/App.jsx";
import { registerVitePreloadRecovery } from "./lib/registerVitePreloadRecovery.js";
import "./index.css";

registerVitePreloadRecovery();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
